import { atom } from "recoil";

export const cartQuantity = atom({
    key: "cartQuantity",
    default: 0,
});